<app-loading-spinner *ngIf="isLoading" class="loading-animation"></app-loading-spinner>
<ng-container *ngIf="!isLoading">
<ng-container *ngFor="let form of forms; let i = index" #toolCodesForms>
    <form [formGroup]="form">
        <div class="tool-number">
            <span class="label">{{ 'admin.tools.form.labels.toolNumber' | translate }}</span>
            <span>{{ +i +1 }}</span>
        </div>

        <app-dropdown-autocomplete
            formControlName="codingType"
            labelAlign="left"
            [formControl]="forms[i].controls.codingType"
            [showErrors]="showValidations"
            [items]="codingTypeOptions"
            displayField="label"
            valueField="value"
            [appendTo]="'body'"
            [label]="'admin.tools.form.labels.codingType' | translate"
            [emptyText]="'admin.tools.form.labels.codingType' | translate"
            [resetSelectionOnItemChange]="false">
        </app-dropdown-autocomplete>

        <ng-container *ngIf="!isToolCodeAutoGenerated(form); else autoGeneratedToolCodeMessage">
            <app-input
                formControlName="mesCode"
                labelAlign="left"
                [showErrors]="showValidations || (forms[i].controls.mesCode.dirty)"
                [formControl]="forms[i].controls.mesCode"
                [isReadonly]="isToolCodeReadonly(form)"
                placeholder="{{ 'admin.tools.form.labels.toolCode' | translate }}"
                label="{{ 'admin.tools.form.labels.toolCode' | translate }}">
            </app-input>
        </ng-container>
        <ng-template #autoGeneratedToolCodeMessage>
            <div class="tool-code-generated-message">
                <span class="label">{{ 'admin.tools.form.labels.toolCode' | translate }}</span>
                <span class="message">{{ 'admin.tools.form.messages.toolCodeAutoGeneratedAfterSave' | translate }}</span>
            </div>
        </ng-template>
        <button
            *ngIf="canReopenInfoModal(form)"
            type="button"
            class="info-modal-reopen"
            (click)="reopenInfoModal(form)"
            [title]="'validation.toolCode.infoModal.title' | translate">
            <i class="material-icons">warning</i>
        </button>
        <app-input formControlName="toolControlName"
                   labelAlign="left"
                   [formControl]="forms[i].controls.toolControlName"
                   [showErrors]="showValidations"
                   placeholder="{{ 'admin.tools.form.labels.toolControlName' | translate }}"
                   label="{{ 'admin.tools.form.labels.toolControlName' | translate }}">
        </app-input>

        <app-input formControlName="supplierCode"
                   labelAlign="left"
                   [formControl]="forms[i].controls.supplierCode"
                   [showErrors]="showValidations"
                   placeholder="{{ 'admin.tools.form.labels.supplierCode' | translate }}"
                   label="{{ 'admin.tools.form.labels.supplierCode' | translate }}">
        </app-input>

        <app-input formControlName="inventoryNumber"
                   labelAlign="left"
                   [formControl]="forms[i].controls.inventoryNumber"
                   [showErrors]="showValidations"
                   placeholder="{{ 'admin.tools.form.labels.inventoryNumber' | translate }}"
                   label="{{ 'admin.tools.form.labels.inventoryNumber' | translate }}">
        </app-input>

    </form>
</ng-container>
</ng-container>
<app-tool-property-validation-info-modal
    #infoModal
    [title]="'validation.toolCode.infoModal.title' | translate"
    [message]="'validation.toolCode.infoModal.message' | translate"
    [tools]="infoModalTools"
    (confirm)="onInfoConfirm()">
</app-tool-property-validation-info-modal>
